import { toast } from "react-toastify";
import api from "./api/api";

interface CadastroAgenciaService {
  type_id: string;
  email: string;
  sector: string;
  business_name: string;
  cnpj: string;
  legal_name: string;
  website: string;
  phone: string;
  zipcode: string;
  city: string;
  state_id: string;
  complement: string;
  discount: string;
  date_init: Date;
  date_finish: Date;
  social_media: {
    value: SocialMediaItem[];
  };
}
interface SocialMediaItem {
  nome: string;
  link: string;
}

const CadastroAgenciaService = {
  listarAgencys: async (
    page: number,
    perPage: number,
    search?: string,
    client_id?: number,
    cidade?: string,
    pais?: string,
    agencyTiposSelect?: number,
  ) => {
    try {
      const params = new URLSearchParams({
        page: String(page),
        perPage: String(perPage),
      });

      if (search) {
        params.append("s", search);
      }
      if (client_id) {
        params.append("cliente_id", String(client_id));
      }
      if (cidade) {
        params.append("cidade", cidade);
      }
      if (pais) {
        params.append("pais", pais);
      }
      if (agencyTiposSelect) {
        params.append("agency_tipo_id", String(agencyTiposSelect));
      }

      const res = await api.get(`agencys?${params.toString()}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  cadastrarAgencys: async (payload: any) => {
    try {
      const res = await api.post(`/agencys`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  deleteAgencys: async (id: any) => {
    try {
      const res = await api.delete(`/agencys/${id}`);
      toast.success("Deletado com sucesso");
      return res;
    } catch (error: any) {
      toast.error(error.response.data.msg);
      toast.error("Erro ao Deletar Usuário");
      return error.response;
    }
  },
  editarAgency: async (payload: any, id: any) => {
    try {
      const res = await api.put(`/agencys/${id}`, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res;
    } catch (error: any) {
      toast.error(error.response.data.msg);
      toast.error("Erro ao Editar Usuário");
      return error.response;
    }
  },
  getAgency: async (id: any) => {
    try {
      const res = await api.get(`/agencys/${id}`);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.msg);
      return error.response;
    }
  },
  savePDI: async (id: any, payload: any) => {
    try {
      const res = await api.post(`/agencys/pdi/${id}`, payload);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.msg);
      return error.response;
    }
  },
  getAgencyTipos: async () => {
    try {
      const res = await api.get(`/agency-tipos`);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.msg);
      return error.response;
    }
  },
  importarAgencys: async (rows: Record<string, any>[]) => {
    try {
      const res = await api.post(`/agencys/import`, { rows });
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
};

export default CadastroAgenciaService;
